/* Koral · movimiento del panel: entrada al hacer scroll, luz que sigue el cursor, cifras que cuentan y líneas que se dibujan. */
(function(){
  var quieto=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var listo=false;
  function contar(el){
    if(el.classList.contains('cnt')||el.dataset.fxN)return;el.dataset.fxN=1;
    var t=el.textContent.trim();if(/mil|—/.test(t))return;
    var m=t.match(/^([^\d]*?)([\d][\d,]*(?:\.\d+)?)(.*)$/);if(!m)return;
    var dec=(m[2].split('.')[1]||'').length,fin=parseFloat(m[2].replace(/,/g,''));if(!isFinite(fin))return;
    var t0=null,dur=1300;
    function f(v){return m[1]+v.toLocaleString('es-MX',{minimumFractionDigits:dec,maximumFractionDigits:dec})+m[3]}
    el.textContent=f(0);
    requestAnimationFrame(function paso(ts){if(!t0)t0=ts;var k=Math.min(1,(ts-t0)/dur),e=1-Math.pow(2,-10*k);
      el.textContent=f(k<1?fin*e:fin);if(k<1)requestAnimationFrame(paso)});
  }
  function dibujar(svg){
    svg.querySelectorAll('path').forEach(function(p){
      if(p.getAttribute('fill')!=='none'||!p.getTotalLength)return;
      var L=p.getTotalLength();p.style.strokeDasharray=L;p.style.strokeDashoffset=L;p.getBoundingClientRect();
      p.style.transition='stroke-dashoffset 1.6s cubic-bezier(.2,.8,.2,1) .2s';p.style.strokeDashoffset=0;
    });
  }
  function iniciar(){
    if(listo)return;listo=true;
    var sel='header.topo,.rotulo-secao,.card,.hk,.igc,.idea,.consejos details,.hero-chips span,.reelrow figure';
    var els=[].slice.call(document.querySelectorAll(sel));
    if(quieto||!('IntersectionObserver' in window)){return}
    els.forEach(function(el){
      el.classList.add('fx-r');
      var hermanos=el.parentNode?[].filter.call(el.parentNode.children,function(x){return x.matches&&x.matches(sel)}):[];
      el.style.setProperty('--fd',(Math.min(hermanos.indexOf(el),8)*0.07)+'s');
    });
    var fun=document.querySelector('.hero-fun');if(fun)fun.classList.add('fx-wait');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(!e.isIntersecting)return;var el=e.target;io.unobserve(el);el.classList.add('fx-in');
      el.querySelectorAll('.hk b,.kpi .valor,.igc-big b,.duo b').forEach(contar);
      if(el.matches('.hk'))el.querySelectorAll('b').forEach(contar);
      el.querySelectorAll('#svgConv,#svgRet').forEach(dibujar);
      if(el.querySelector('.hero-fun')){setTimeout(function(){fun.classList.add('fx-go')},250)}
    })},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){io.observe(el)});
    /* luz que sigue el cursor */
    document.addEventListener('pointermove',function(e){
      var c=e.target.closest&&e.target.closest('.card,.hk,.kpi');if(!c)return;
      var r=c.getBoundingClientRect();c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px');
    },{passive:true});
    /* botón magnético */
    document.querySelectorAll('.cta').forEach(function(b){
      b.addEventListener('pointermove',function(e){var r=b.getBoundingClientRect();b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.12)+'px,'+((e.clientY-r.top-r.height/2)*.25)+'px)'});
      b.addEventListener('pointerleave',function(){b.style.transform=''});
    });
  }
  document.addEventListener('koral:open',function(){requestAnimationFrame(iniciar)});
  function auto(){if(!document.getElementById('kLock'))iniciar()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',auto);else auto();
})();
